import React, { useState } from "react";
import { MapPinIcon } from "@heroicons/react/24/outline";
import { useAllRetailersQuery } from "../../app/apiSlices/clientSlice";
import Pagination from "../Pagination";

const RetailerList = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const { data: retailersList, isLoading } = useAllRetailersQuery(
    { page: currentPage },
    {
      refetchOnMountOrArgChange: true,
    }
  );
  if (!retailersList)
    return (
      <div className="flex items-center justify-center py-10 w-full mx-auto">
        <svg
          aria-hidden="true"
          className=" w-8 h-8 text-gray-200 animate-spin  fill-white"
          viewBox="0 0 100 101"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
            fill="currentColor"
          />
          <path
            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
            fill="currentFill"
          />
        </svg>
      </div>
    );

  const { pages } = retailersList?.data;

  return (
    <div className="w-full max-w-7xl mx-auto">
      <div className="bg-white w-full flex items-center justify-between p-4 mt-20">
        <h1>Retailers List</h1>
      </div>
      {/* Table for RLIST */}
      <div className="w-full bg-white">
        {/* Add classes to handle overflow for mobile devices */}
        <table className="w-full overflow-x-scroll">
          <thead className="border-b border-[1px] border-[#F2F2F2]">
            <tr className="text-left">
              <th className="font-light px-4 py-4">S/N</th>
              <th className="font-light px-4 py-4">Name</th>
              <th className="font-light px-4 py-4">Store Address</th>
              <th className="font-light px-4 py-4">Registration Date</th>
              <th className="font-light px-4 py-4">ASR</th>
              <th className="font-light px-4 py-4">Orders made</th>
              <th className="font-light px-4 py-4">Repeat Orders</th>
              <th className="font-light px-4 py-4">Registered Location</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {retailersList?.data?.retailers.map(
              (item: IRetailer, index: number) => (
                <tr
                  key={index}
                  className="py-4 font-light text-[#828282] text-sm border-b border-[1px] border-[#F2F2F2]"
                >
                  <td className="px-4 py-4">{index + 1}</td>
                  <td className="px-4 py-4">{item.store_name}</td>
                  <td className="px-4 py-4 underline text-[#2D5EDB] cursor-pointer">
                    <a
                      href={`https://maps.google.com/?q=${item.address}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {item.address.length > 30 ? (
                        <p>{item.address.slice(0, 30)}...</p>
                      ) : (
                          <p>{item.address}</p>
                        )}
                    </a>
                  </td>
                  <td className="px-4 py-4">{item.created_at.split("T")[0]}</td>
                  <td className="px-4 py-4 text-[#2CC56F]">{item.asr.name}</td>
                  <td className="px-4 py-4">{item.orders_count}</td>
                  <td className="px-4 py-4">
                    {item.orders_count > 0 ? item.orders_count - 1 : "-"}
                  </td>
                  <td className="px-4 py-4">
                    <a
                      href={`https://www.google.com/maps/search/${item.captured_latitude},${item.captured_longitude}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <MapPinIcon className="h-5 w-5 hover:text-red-500 hover:font-bold text-[#2D5EDB]" />
                    </a>
                  </td>
                </tr>
              )
            )}
          </tbody>
        </table>
      </div>
      {pages > 1 && !isLoading && (
        <Pagination
          nPages={pages}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      )}
    </div>
  );
};

export default RetailerList;

interface IRetailer {
  address: string;
  asr: {
    email: any;
    id: number;
    name: string;
    phone: string;
  };
  captured_latitude: string;
  captured_longitude: string;
  created_at: string;
  id: number;
  image: string;
  name: string;
  orders_count: number;
  phone: string;
  store_name: string;
  subregion: {
    id: number;
    name: string;
    code: string;
    region_id: number;
  };
}
